import { useCallback, useState } from "react";

import CloudinaryImage from "@/components/cloudinary-image";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { formatDateDisplay } from "@/helpers/parsers";
import { useIsBreakPoint } from "@/hooks/use-is-break-point";

import type { BadgeType } from "../../types";
import DetailsModal from "./details-modal";

interface BadgeProps {
  badge: BadgeType;
}

export default function Badge({ badge }: BadgeProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const isDesktop = useIsBreakPoint("md");

  const handleClick = useCallback(() => {
    if (!isDesktop) {
      setIsDialogOpen(true);
    }
  }, [isDesktop]);

  if (!badge.image) {
    return null;
  }

  return (
    <>
      <HoverCard>
        <HoverCardTrigger asChild>
          <CloudinaryImage
            alt={badge.name}
            className="aspect-square w-full shadow-white/50 transition-shadow hover:shadow-0-0-20 md:rounded-full"
            imageId={badge.image}
            onClick={handleClick}
            rW={256}
          />
        </HoverCardTrigger>
        <HoverCardContent className="hidden w-80 flex-col gap-[15px] rounded-[15px] bg-[url(/images/main-bg.jpg)] bg-cover bg-top bg-no-repeat p-5 shadow-0-0-8 shadow-black/50 md:flex">
          <h4 className="text-center font-medium text-16/[1.5em] text-white">
            {badge.name}
          </h4>
          {!!badge.earnedAt && (
            <h5 className="text-center font-normal text-13/[1.5em] text-white/50">
              Unlocked on {formatDateDisplay(badge.earnedAt)}
            </h5>
          )}
          <p className="text-center text-14/[1.7em] text-pale-lavender">
            {badge.description}
          </p>
        </HoverCardContent>
      </HoverCard>
      <DetailsModal
        badge={badge}
        onOpenChange={setIsDialogOpen}
        open={isDialogOpen}
      />
    </>
  );
}
